import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Box, Dialog, DialogTitle, DialogContent, Typography, IconButton } from '@mui/material';

import { Warning, Close } from '@mui/icons-material';

const PREFIX = 'NoTouchDelivery';

const localClasses = {
  here: `${PREFIX}-here`,
  description: `${PREFIX}-description`,
  listItems: `${PREFIX}-listItems`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`& .${localClasses.here}`]: {
    cursor: 'pointer',
    fontWeight: 700,
    padding: '0 4px',
    textDecoration: 'underline',
  },

  [`& .${localClasses.description}`]: {
    color: theme.colorTokens.onSurfaceTextTitle,
    fontWeight: 700,
    fontSize: 13,
  },

  [`& .${localClasses.listItems}`]: {
    fontSize: 13,
    lineHeight: 1.5,
    paddingLeft: 12,
    color: theme.colorTokens.onSurfaceTextLabel,
    '& *:not(:last-of-type)': {
      marginBottom: 8,
    },
  },
}));

function NoTouchDelivery({ classes }) {
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <StyledBox sx={classes.topAlert}>
      <Warning sx={classes.topAlertIcon} />
      <span>With the current situation around COVID-19, Jitsu's priority is the safety of you and our drivers. We have created the </span>
      <span style={{ fontWeight: 700 }}>No-Touch Attended Deliveries</span> feature for our deliveries. Click
      <span className={localClasses.here} onClick={() => setOpenDialog(true)}>
        here
      </span>
      <span>to view the procedure in detail.</span>
      <p>
        If you want the delivery left at the door, please go into "Manage Delivery" and change your preferences in the "Signature option" section.
      </p>
      <Dialog open={openDialog}>
        <IconButton onClick={() => setOpenDialog(false)} style={{ position: 'absolute', top: '10px', right: '10px', padding: '5px' }} size="large">
          <Close />
        </IconButton>
        <DialogTitle>
          <strong className={classes.textOnSurfaceTextHeadline}>No-Touch Attended Delivery</strong>
        </DialogTitle>
        <DialogContent dividers>
          <Typography className={localClasses.description}>Here is what the no-touch attended delivery procedure will look like:</Typography>
          <ul className={localClasses.listItems}>
            <li>
              You have the option of signing at any point after the order has been picked up from the facility via the “Provide Signature” button on
              the tracking link.
            </li>
          </ul>
          <ul style={{ padding: 0 }}>
            <li style={{ listStyle: 'none' }}>
              <hr className="hr-text" data-content="OR" />
            </li>
          </ul>
          <ul className={localClasses.listItems}>
            <li>Once the driver arrives at your delivery location, they will place the shipment near the door.</li>
            <li>They will take a few steps back and send you a signature request via SMS.</li>
            <li>You will be sent a unique link where you can sign for the delivery on your own device.</li>
            <li>You may stay indoors or open the door to check your delivery, whatever is more comfortable for you.</li>
            <li>Once you save the signature, the driver will receive it and the delivery is complete.</li>
          </ul>
        </DialogContent>
      </Dialog>
    </StyledBox>
  );
}

export default NoTouchDelivery;
